// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import intvmsgEntity from './entities/intvmsg.json';
import intvmsgMenu from '../pages/intvmsg/menu.json';
import intvmsgFullForm from '../pages/intvmsg/forms/full.json';
import intvmsgContextForm from '../pages/intvmsg/forms/context.json';
import intvmsgMiniForm from '../pages/intvmsg/forms/mini.json';
import intvmsgLookupForm from '../pages/intvmsg/forms/lookup.json';
import intvmsgTableView from '../pages/intvmsg/views/table.json';
import intvmsgStagesView from '../pages/intvmsg/views/stages.json';
import intvmsgCardsView from '../pages/intvmsg/views/cards.json';
import intvmsgInlineView from '../pages/intvmsg/views/inline.json';
import intvmsgBacklogView from '../pages/intvmsg/views/backlog.json';
import intvmsgSplitView from '../pages/intvmsg/views/split.json';
import intvmsgCalendarView from '../pages/intvmsg/views/calendar.json';
import intvmsgDashboardView from '../pages/intvmsg/views/dashboard.json';

/** Тип запису «Теза» зі сторінками пакета: меню, форми та подання з pages/intvmsg/. */
export const intvmsgDefinition: IRecordTypeDefinition = {
  ...intvmsgEntity,
  views: assembleViewSet({
      table: intvmsgTableView,
      stages: intvmsgStagesView,
      cards: intvmsgCardsView,
      inline: intvmsgInlineView,
      backlog: intvmsgBacklogView,
      split: intvmsgSplitView,
      calendar: intvmsgCalendarView,
      dashboard: intvmsgDashboardView,
  }),
  form: intvmsgFullForm,
  forms: { full: intvmsgFullForm, context: intvmsgContextForm, mini: intvmsgMiniForm, lookup: intvmsgLookupForm },
  menu: intvmsgMenu,
} as IRecordTypeDefinition;
